// smooth scroll
$('a[href^="#"]').on('click', function(e) {
  let attr = $(this).attr('href');
  let target = $(document.getElementById(attr.replace('#', '')));
  if (!target.length) {
    return;
  }
  e.preventDefault();
  
  $('html, body').animate({
      scrollTop: target.offset().top - 100,
    }, 1000, 'swing');
});
